<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <form @submit.prevent="submitData" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ !isEdit ? $t('userGroup.creation') : $t('userGroup.modification') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                    fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                    fill="currentColor" />
                </svg>
              </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <div class="row">
              <Input
                  containerClass="col-12 mt-auto mb-5"
                  :name="`${id}-name`"
                  type="text"
                  :label="$t('userGroup.label.name')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="true" size="lg"
                  :placeholder="$t('userGroup.placeholder.name')"
                  v-model="formData.name"
              />
              <Select2
                  :parent-id="`#${id}`"
                  containerClass="col-12 mt-auto mb-5"
                  :name="`${id}-sub-categories`"
                  :multiple="true"
                  :label="$t('userGroup.label.users')"
                  labelClass="d-flex align-items-center fs-6 fw-bold mb-2"
                  selectClass="form-select form-select-solid"
                  :isRequired="false"
                  :placeholderText="$t('userGroup.placeholder.users')"
                  v-model="formData.ids"
              >
                <option v-for="(user, index) in users" :key="id+index" :value="user.id">
                  {{ user.fullname }}
                </option>
              </Select2>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>

import { computed, ref, defineProps, watch } from "vue";
import Select2 from "@/components/Select2.vue";
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText"
import Button from "@/components/Button"
import Input from "@/components/Input.vue";

const store = useStore()
const props = defineProps({
  userGroup: {
    type: Object,
    default: {
      id: '',
      name: '',
      ids: [],
    }
  },
  id: {
      type: String,
      required: true
  },
  parent: String,
  isEdit: { type: Boolean, default: false }
})

const emits = defineEmits(['callback'])

const currentUser = computed(() => store.getters['user/currentUser'])
const allUsers = computed(() => store.getters['user/getUsers'])
const users = computed(() => {
  if(!allUsers.value && !allUsers.value.length) return []
  return allUsers.value.filter(user => user.office_id === currentUser.value.office_id)
})

const formData = ref({
  id: '',
  name: '',
  ids: [],
})
const isLoading = ref(false)

watch(() => props.userGroup, (value) => {
  formData.value.id = value?.id
  formData.value.name = value?.name
  formData.value.ids = value?.ids
})

function submitData(){
  if(!props.isEdit){
    createUserGroup()
  }else{
    updateUserGroup()
  }
}

function createUserGroup() {

  isLoading.value = true
  store.dispatch('usersGroups/createUserGroup', formData.value)
    .then((response) => {
      emits('callback', response?.data?.data?.id)
      isLoading.value = false
      closeModal()
      window.toastr['success'](i18n.global.t('userGroup.notification.group_created'))
    })
    .catch(err => {
      isLoading.value = false
    })
}

function updateUserGroup() {

  isLoading.value = true
  store.dispatch('usersGroups/updateUserGroup', formData.value)
    .then((response) => {
      emits('callback')
      isLoading.value = false
      closeModal()
      window.toastr['success'](i18n.global.t('userGroup.notification.group_updated'))
    })
    .catch(err => {
      isLoading.value = false
    })
}


function closeModal() {
  if(props.parent){
    $('#'+props.parent).modal('toggle')
  }
  $('#'+props.id).modal('toggle')
  formData.value.id = ''
  formData.value.name = ''
  formData.value.ids = []
}
</script>

<style scoped></style>
